import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  inputContainer: {
    width: "100%",
    position: "relative",
    fontFamily: theme.fontFamilyQuestrial,
  },
  errorMessage: {
    position: "absolute",
    right: 0,
    top: "-14px",
    fontSize: "0.5rem",
    color: theme.lightCoralColor,
  },
  input: (props: any) => ({
    width: "100%",
    border: `1px solid ${theme.lighterSnowColor}`,
    padding: "0 0.5rem",
    paddingLeft: "0.3rem",
    paddingTop: "18px",
    paddingBottom: "5px",
    fontSize: "0.8rem",
    fontFamily: theme.fontFamilyQuestrial,
    color: props.disabled ? theme.darkerSlateGrayColor : theme.dimGrayColor,
    backgroundColor: theme.whiteColor,
  }),
  label: (props: any) => ({
    position: "absolute",
    left: "9px",
    top: props.focused || props.filled || props.selected ? "6px" : "11px",
    fontSize:
      props.focused || props.filled || props.selected ? "0.5rem" : "0.7rem",
    color: theme.grayColor,
    pointerEvents: "none",
    transition: "all 300ms ease-out",
  }),
}));

export default useStyles;
